import { AppRoutes } from '@/constants';
import { isUuidLike } from '@/utils';

export type CloneKind = 'chat' | 'case';

const UUID_PATTERN = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';

/** The id segment in `/chat/:chatId`, `/projects/:projectId/chat/:chatId` and `/cases/:caseId`. */
const LINK_ID_RE: Record<CloneKind, RegExp> = {
  chat: new RegExp(`/${AppRoutes.Chat}/(${UUID_PATTERN})(?:[/?#]|$)`),
  case: new RegExp(`/${AppRoutes.Cases}/(${UUID_PATTERN})(?:[/?#]|$)`),
};

/** Reads a bare UUID, or a Fletch link to the chat or case. `null` when it is neither. */
export const parseCloneId = (text: string, kind: CloneKind): string | null => {
  const value = text.trim();
  const id = isUuidLike(value) ? value : LINK_ID_RE[kind].exec(value)?.[1];
  return id ? id.toLowerCase() : null;
};
